import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

const CompleteStreetsPlan = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
     

      {/* Overview Paragraph */}
      <Box component="main" sx={{ p: 4, textAlign: 'center' }}>
              <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('complete_streets_plan.title', 'Overview')}
      </Typography>
        <Typography
          variant="body1"
          sx={{
            maxWidth: '800px',
            mx: 'auto',
            textAlign: 'justify',
            fontSize: { xs: '1rem', sm: '1.25rem' },
            lineHeight: 1.6,
          }}
        >
          {t('complete_streets_plan.description')}
        </Typography>
      </Box>

{/*Greenway Master Plan Update Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: { xs: 'auto', md: '500px' },
    overflowX: 'hidden',
  }}
>
  {/* Left Column */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      boxSizing: 'border-box',
      bgcolor: '#00539b',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('complete_streets_plan.get_involved_title', 'Complete Streets Master Plan Update')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t('complete_streets_plan.get_involved_text')}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
           onClick={() => {
  navigate('/miami-lakes-public-input');
   window.scrollTo({ top: 0, behavior: 'smooth' });
}}
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('complete_streets_plan.get_involved_button', 'Get Involved')}
        </Button>
      </Box>
    </Box>
  </Box>


{/* Right Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '500px', md: 'auto' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/complete-streets-plan-get-involved.jpg`}
    alt={t('complete-streets-plan-get-involved_img_alt', 'Complete Streets Master Plan Update')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    }}
  />

  {/* Dark overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity as needed
    }}
  />
</Box>

</Box>

      {/* Public Input Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: 'auto',
    overflowX: 'hidden',
  }}
>
  {/* Left Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '400px', md: '5' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/complete-streets-plan-public-input.jpg`}
    alt={t('complete_streets_plan.public_input_image_alt', 'Public Input')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    }}
  />

  {/* Dark overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity to taste
    }}
  />
</Box>


  {/* Right Column (Text) */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      bgcolor: 'white',
      color: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('complete_streets_plan.public_input_title', 'Public Input')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t(
          'complete_streets_plan.public_input_text'        )}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
           onClick={() => {
  navigate('/miami-lakes-public-input');
   window.scrollTo({ top: 0, behavior: 'smooth' });
}}
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('complete_streets_plan.public_input_button', 'Public Input')}
        </Button>
      </Box>
    </Box>
  </Box>
</Box>










    </div>
  );
};

export default CompleteStreetsPlan;